import React from "react";
import Box from "@material-ui/core/Box";
import {TabPanelProps} from "../../../Models/TabPanelProps";
import {makeStyles, Theme} from "@material-ui/core/styles";

export function TabPanel (props: TabPanelProps) {
  const {children, value, index, ...other} = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

export  function a11yProps (index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}



export const useStylesTab = makeStyles ((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: "white"
  },
  mainTab: {
    backgroundColor: "white"
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }
}));
